import React from 'react';
import styles from '../styles/Footer.module.css'; // Tạo file CSS tương tự

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>&copy; 2025 MamViet. All rights reserved.</p>
    </footer>
  );
};

export default Footer;